import type { Template } from 'apis/templates';

export const getLanguageSpecificContent = (
  language: string,
  template: Template | undefined,
): string => {
  if (!template) return '';
  /**
   * Beware, templates.translations can be null and therefore return
   * template.content if template.translations is null.
   */
  if (!template.translations) {
    return template?.content;
  }

  return template.translations[language]?.content || template.content;
};

export const getLanguageSpecificSubject = (
  language: string,
  template: Template | undefined,
): string => {
  if (!template) return '';
  /**
   * Beware, templates.translations can be null and therefore return
   * template.subject if template.translations is null.
   */
  if (!template.translations) {
    return template?.subject || '';
  }

  return template.translations[language]?.subject || template.subject || '';
};
